<div mat-dialog-title
     class="contest-registration-dialog__header">
    <h2 *ngIf="isCollective()" class="contest-registration-dialog__title">{{ "contest.register_class" | translate }}</h2>
    <h2 *ngIf="!isCollective()" class="contest-registration-dialog__title">{{ "contest.register_alone" | translate }}</h2>
    <button mat-button
            class="contest-registration-dialog__close-button"
            (click)="dialogRef.close()"
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>
<mat-dialog-content class="contest-registration-dialog__content">
    <form [formGroup]="registrationForm"
          class="contest-registration-dialog__form">
        <div class="contest-registration-dialog__institution" *ngIf="!isEditing">
            <h3 class="contest-registration-dialog__institution-title">{{ "contest.institution_informations" | translate }}</h3>
            <div class="contest-registration-dialog__institution-wrapper">
                <mat-form-field class="contest-registration-dialog__postal-code-field"
                                floatLabel="always">
                    <mat-label>{{ "generic.postal-code" | translate }}</mat-label>
                    <input type="text"
                           matInput
                           [formControlName]="'postalCode'"
                    >
                </mat-form-field>
                <!-- Autocomplete pour le nom de l'établissement -->
                <mat-form-field class="contest-registration-dialog__institution-name-field"
                                floatLabel="always" *ngIf="contest.collective">
                    <mat-label>{{ "groups-management.institution_name" | translate }}</mat-label>
                    <input type="text"
                           matInput
                           [formControlName]="'establishmentName'"
                           [matAutocomplete]="auto2"
                    >
                    <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let etab of filteredEstablishments"
                                    [value]="etab">
                            <span matTooltip="{{etab.get('name')}} ({{ etab.get('city') }})">{{ etab.get('name') }} ({{ etab.get('city') }})</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="contest-registration-dialog__groups" *ngIf="contest.collective">
            <h3 class="contest-registration-dialog__groups-title">{{ "contest.selecting_groups" | translate }}</h3>
            <div *ngIf="classes && classes.length > 0; else noClasses" formArrayName="selectedClasses"
                 class="contest-registration-dialog__groups-wrapper">
                <mat-checkbox *ngFor="let classe of classes; let i = index"
                              [formControlName]="i"
                              class="contest-registration-dialog__group-checkbox"
                              labelPosition="before"
                              disableRipple="true">
                    <label class="contest-registration-dialog__group-label">
                        <div class="contest-registration-dialog__group-avatar">6a</div>
                        <div class="contest-registration-dialog__group-name">{{ classe.get('label') }}</div>
                        <div class="contest-registration-dialog__group-learners">
                            <mat-icon svgIcon="group-outlined-fill"></mat-icon>
                            <div>{{ classe.get('membersCount') }}</div>
                        </div>
                    </label>
                </mat-checkbox>
            </div>
            <ng-template #noClasses>
                <div class="no-classes-message">
                    {{ 'contest.no_groups' | translate }}
                </div>
            </ng-template>
        </div>

        <div class="contest-registration-dialog__sponsor" *ngIf="!isEditing && isCollective()">
            <h3 class="contest-registration-dialog__sponsor-title">{{ "contest.sponsor_code" | translate }}</h3>
            <mat-form-field class="contest-registration-dialog__sponsor-code-field"
                            floatLabel="always">
                <mat-label>{{ "contest.code" | translate }}</mat-label>
                <input type="text"
                       matInput
                       formControlName="shareableCode">
            </mat-form-field>
            <mat-error *ngIf="registrationForm.get('shareableCode').hasError('erreur')">
                {{ error }}
            </mat-error>
        </div>
        <div class="contest-registration-dialog__consent" *ngIf="requireConsent">
            <mat-checkbox formControlName="consent">
                {{ 'contest.consent' | translate }} *
            </mat-checkbox>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="contest-registration-dialog__footer">
    <p class="contest-registration-dialog__required-fields-info">{{ "contest.required_fields" | translate }}</p>
    <button mat-button
            type="submit"
            [disabled]="!registrationForm.valid || isRegistering"
            class="contest-registration-dialog__validate-button"
            (click)="handleRegister()">
        <div>{{ "generic.validate" | translate }}</div>
        <mat-icon svgIcon="check-rounded" *ngIf="!isRegistering; else spinnerBlock"></mat-icon>
        <ng-template #spinnerBlock>
            <mat-spinner diameter="24"></mat-spinner>
        </ng-template>
    </button>
</mat-dialog-actions>